"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Operator = void 0;
var Operator;
(function (Operator) {
    Operator["BEGINNING_WITH"] = "$bw";
    Operator["BETWEEN"] = "$bt";
    Operator["CONTAINING"] = "$ct";
    Operator["ENDING_WITH"] = "$ew";
    Operator["EQUALS_TO"] = "$eq";
    Operator["GREATER_THAN"] = "$gt";
    Operator["GREATER_THAN_OR_EQUALS_TO"] = "$gte";
    Operator["IN"] = "$in";
    Operator["LESS_THAN"] = "$lt";
    Operator["LESS_THAN_OR_EQUALS_TO"] = "$lte";
    Operator["NOT_BEGINNING_WITH"] = "$nbw";
    Operator["NOT_CONTAINING"] = "$nct";
    Operator["NOT_ENDING_WITH"] = "$new";
    Operator["NOT_EQUALS_TO"] = "$ne";
})(Operator = exports.Operator || (exports.Operator = {}));
//# sourceMappingURL=Operator.js.map